import { atom } from 'jotai';

export interface SearchAtom {
  /**
   * Determines whether the search box/modal is currently open.
   */
  isOpen: boolean;
}

export const searchAtom = atom<SearchAtom>({ isOpen: false });
